import { Icon } from '../../../common/view/icon/icon';
import { MonoIcon } from '../../../common/view/icon/mono/mono-icon';
import { NodeItemActionSnoozeStyle } from './node-item-action-snooze.style';

export function NodeItemActionSnooze() {
  return (
    <NodeItemActionSnoozeStyle.Container>
      <Icon icon={MonoIcon.snoozeSleep} size="16px" />
    </NodeItemActionSnoozeStyle.Container>
  );
}
